import React from 'react';
import { Card, Row, Col } from 'antd';
import { connect } from 'dva';
import styles from './Card.less';
import ReadOnlyFile from '../components/ReadOnlyFile.js';

@connect(({ merchantBusinessMy, loading }) => ({
  loading: loading.effects['merchantBusinessMy/fetchFullInfo'],
  fullInfo: merchantBusinessMy.fullInfo,
}))
export default class BaseInfoCard extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({ type: 'merchantBusinessMy/fetchFullInfo' });
  }

  render() {
    const { labelLayout, contentLayout, fullInfo, loading } = this.props;

    return (
      <Card title="基础资料" loading={loading} className={styles.root} bordered={false}>
        <Row>
          <Col {...labelLayout}>商户基础资料：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.excelFileUrl} />
          </Col>
        </Row>

        <Row>
          <Col {...labelLayout}>经营许可证：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.operationLicenseUrl} />
          </Col>
        </Row>

        <Row>
          <Col {...labelLayout}>办学许可证：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.schoolLicenseUrl} />
          </Col>
        </Row>

        <Row>
          <Col {...labelLayout}>营业执照照片：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.businessLicenseUrl} />
          </Col>
        </Row>

        <Row>
          <Col {...labelLayout}>组织机构代码证照片：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.organizationCodeCertificateUrl} />
          </Col>
        </Row>

        <Row>
          <Col {...labelLayout}>身份证正面照片：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.identityFrontUrl} />
          </Col>
        </Row>

        <Row>
          <Col {...labelLayout}>身份证反面照片：</Col>
          <Col {...contentLayout}>
            <ReadOnlyFile url={fullInfo.identityReverseUrl} />
          </Col>
        </Row>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Card/BaseInfo.js